import gql from "graphql-tag";

export const CREATE_ORGANIZATION = gql`
  mutation AddOrganization($data: OrganizationDataInput) {
    addOrganization(data: $data) {
      id
    }
  }
`;

export const CREATE_ORGANIZATIONS = gql`
  mutation AddOrganizations($data: [OrganizationDataInput]) {
    addOrganizations(data: $data) {
      id
    }
  }
`;

export const CREATE_ENTERPRISE = gql`
  mutation AddEnterprise($data: EnterpriseDataInput) {
    addEnterprise(data: $data) {
      id
    }
  }
`;

export const UPDATE_ORGANIZATION = gql`
  mutation UpdateOrganization(
    $data: OrganizationDataInput
    $where: OrganizationWhereInput
  ) {
    updateOrganization(where: $where, data: $data) {
      id
    }
  }
`;

export const DELETE_ORGANIZATION = gql`
  mutation DeleteOrganization($where: OrganizationWhereInput) {
    deleteOrganization(where: $where) {
      id
    }
  }
`;

export const IMPORT_ORGANIZATIONS_FROM_FILE = gql`
  mutation ImportOrganizationsFromFile($data: ImportOrganizationsInput) {
    importOrganizationsFromFile(data: $data) {
      id
    }
  }
`;

export const DUPLICATE_ORGANIZATION = gql`
  mutation DuplicateOrganization(
    $where: OrganizationWhereInput
    $data: DuplicateOrganizationDataInput
  ) {
    duplicateOrganization(where: $where, data: $data) {
      id
    }
  }
`;

const organizations = {
  CREATE_ORGANIZATION,
  CREATE_ENTERPRISE,
  UPDATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  IMPORT_ORGANIZATIONS_FROM_FILE,
  CREATE_ORGANIZATIONS,
  DUPLICATE_ORGANIZATION,
};

export default organizations;
